import { useCallback } from 'react';
import { useLingui } from '@lingui/react';
import { useFilterByPrimaryDimensionDeviceId, makeGetBrowserNameWithTranslation } from '../utils';
import { usePersonDeviceTransformApi } from './api';

export const usePersonDevicesBrowsername = () => {
  const {
    _,
  } = useLingui();
  const transformFunction = useCallback(makeGetBrowserNameWithTranslation(_), [_]);
  const filterPredicate = useFilterByPrimaryDimensionDeviceId();
  const result = usePersonDeviceTransformApi({
    filterPredicate,
    transformFunction,
  });
  return result;
};
